<template>
  <m-contents-wrapper content-type="post" :pause-if-category-not-found="true"
                      :content-category="findCategories(content.category)">
    <div slot-scope="{contents}">
      <b-col lg="12">
        <b-row align-h="center">
          <b-col class="my-3" lg="4" v-if="sub_content.id != content.id" v-for="sub_content in contents"
                 :key="sub_content.id">
            <m-c303 :image="sub_content.thumbnail" :alt="sub_content.title">

              <m-a class="text-dark" :href="{name:'SinglePost',params:{slug:sub_content.slug}}">
                <h5>{{ sub_content.title }}</h5>
              </m-a>

              <m-a :href="{name:'SinglePost',params:{slug:sub_content.slug}}">
                <b-button class="border-0 text-muted font-weight-bold" variant="transparent" size="sm">
                  <span class="pl-1">بیشتر بخوانید</span>
                  <b-icon icon="arrow-left"/>
                </b-button>
              </m-a>


            </m-c303>
          </b-col>
        </b-row>
      </b-col>

    </div>
  </m-contents-wrapper>
</template>

<script>
export default {
  name: "PostsRelated300",
  props: {
    content: {}
  },
  methods: {
    findCategories(categories) {
      categories = categories.map(item => {
        return item.slug
      })
      return categories.length == 0 ? null : categories
    }
  }
}
</script>

<style scoped>

</style>